import { GetGlobalSearchResultsPresenter } from '../../features/get-global-search-results/presenters/GetGlobalSearchResultsPresenter'
import { useGlobalSearchHotkey } from '../../hooks/useGlobalSearchHotkey'
import { useGlobalSearch } from '../../providers/GlobalSearchProvider'

export const GlobalSearchView = () => {
  const { isOpen, open, close } = useGlobalSearch()

  useGlobalSearchHotkey(open)

  return <GetGlobalSearchResultsPresenter isOpen={isOpen} onClose={close} />
}
